import { AbpHttpInterceptor } from 'abp-ng2-module';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { CustomAbpHttpInterceptor } from '@shared/common/session/custom-abp-http-interceptor';

import * as ApiServiceProxies from './service-proxies';

@NgModule({
    providers: [
        ApiServiceProxies.AuditLogServiceProxy,
        ApiServiceProxies.CachingServiceProxy,
        ApiServiceProxies.CommonLookupServiceProxy,
        ApiServiceProxies.ContactServiceProxy,
        ApiServiceProxies.EditionServiceProxy,
        ApiServiceProxies.HostSettingsServiceProxy,
        ApiServiceProxies.LanguageServiceProxy,
        ApiServiceProxies.NotificationServiceProxy,
        ApiServiceProxies.OrganizationUnitServiceProxy,
        ApiServiceProxies.PermissionServiceProxy,
        ApiServiceProxies.ProfileServiceProxy,
        ApiServiceProxies.RoleServiceProxy,
        ApiServiceProxies.SessionServiceProxy,
        ApiServiceProxies.TenantServiceProxy,
        ApiServiceProxies.TenantDashboardServiceProxy,
        ApiServiceProxies.TenantSettingsServiceProxy,
        ApiServiceProxies.TimingServiceProxy,
        ApiServiceProxies.UserServiceProxy,
        ApiServiceProxies.PartnerServiceProxy,
        ApiServiceProxies.PartnerContractTermServiceProxy,
        ApiServiceProxies.ProviderServiceProxy,
        ApiServiceProxies.ProductServiceProxy,
        ApiServiceProxies.QuotesServiceProxy,
        ApiServiceProxies.OrderServiceProxy,
        ApiServiceProxies.OrderUserServiceProxy,
        ApiServiceProxies.OrderSalesAgentServiceProxy,
        ApiServiceProxies.CustomerServiceProxy,
        ApiServiceProxies.CustomerLocationServiceProxy,
        ApiServiceProxies.ActivityServiceProxy,
        ApiServiceProxies.UserLoginServiceProxy,
        ApiServiceProxies.WebLogServiceProxy,
        ApiServiceProxies.ContractTermServiceProxy,
        ApiServiceProxies.CommissionServiceProxy,
        ApiServiceProxies.AgentAccountRateServiceProxy,
        ApiServiceProxies.DocumentStorageServiceProxy,
        ApiServiceProxies.MasterAgencyServiceProxy,
        ApiServiceProxies.BillingServiceProxy,
        ApiServiceProxies.EventServiceProxy,
        ApiServiceProxies.DepartmentServiceProxy,
        ApiServiceProxies.StatusAutomationServiceProxy,
        ApiServiceProxies.ActionServiceProxy,
        ApiServiceProxies.RequestorServiceServiceProxy,
        ApiServiceProxies.ImportServiceProxy,
        ApiServiceProxies.ImportUploadServiceProxy,
        ApiServiceProxies.ContractRenewalServiceProxy,
        ApiServiceProxies.CommissionChurnReportServiceProxy,
        ApiServiceProxies.ProviderOrderStatusServiceProxy,
        ApiServiceProxies.AdjustmentScheduleItemServiceProxy,
        ApiServiceProxies.AdjustmentScheduleServiceProxy,
        ApiServiceProxies.TicketServiceProxy,
        ApiServiceProxies.TicketWorkflowAutomationServiceProxy,
        ApiServiceProxies.AttributeServiceProxy,
        ApiServiceProxies.PartnerAcquisitionServiceProxy,
        ApiServiceProxies.ProviderPortalAdminServiceProxy,
        ApiServiceProxies.TerritoryServiceProxy,
        ApiServiceProxies.CommissionReviewsServiceProxy,
        ApiServiceProxies.SupervisorTeamServiceProxy,
        ApiServiceProxies.SalesCampaignServiceProxy,
        { provide: HTTP_INTERCEPTORS, useClass: CustomAbpHttpInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: AbpHttpInterceptor, multi: true }
    ],
})
export class ServiceProxyModule {}
